import { Injectable } from '@angular/core';
import { deleteMandate, updateMPayThreshold } from '../configs/entity.config';
import { EntityManager } from '@proximus/entity-manager';

@Injectable({
  providedIn: 'root',
})
export class MpayService {
  constructor() {}

  updateMpaythreshold(params) {
    const iEntity = EntityManager.createEntity(updateMPayThreshold, {});
    iEntity.value = params;
    return EntityManager.saveEntity(iEntity);
  }

  deleteMandate(mandateId: string, accessNumber: string) {
    const iEntity = EntityManager.createEntity(deleteMandate, {});
    iEntity.value = {
      msisdn: accessNumber,
      mandateIDs: [mandateId],
    };
    return EntityManager.updateEntity(iEntity);
  }
}
